import { Card } from 'reactstrap';
import CardInner from '../../../components/cards/CardInner';
import CardTitleGroup from '../../../components/cards/CardTitleGroup';

const AnimatedDots = () => (
  <span className="deal-proj-loader-dots">
    <span>.</span>
    <span>.</span>
    <span>.</span>
    <style>{`
      .deal-proj-loader-dots span {
        animation: deal-proj-loader-bounce 1.4s infinite both;
        font-size: 2rem;
        color: #854fff;
        margin: 0 2px;
        font-weight: bold;
      }
      .deal-proj-loader-dots span:nth-child(2) {
        animation-delay: 0.2s;
      }
      .deal-proj-loader-dots span:nth-child(3) {
        animation-delay: 0.4s;
      }
      @keyframes deal-proj-loader-bounce {
        0%, 80%, 100% { transform: scale(1); opacity: 0.7; }
        40% { transform: scale(1.4); opacity: 1; }
      }
    `}</style>
  </span>
);

const DealProjectionsLoader = () => (
  <Card className="w-100 mt-4 p-4" >
    <CardInner className="d-flex flex-column align-items-center justify-content-center">
      <CardTitleGroup>
        <h5 className="mb-3" style={{ color: '#854fff', fontWeight: 600, letterSpacing: 1 }}>
          Loading projections data <AnimatedDots />
        </h5>
      </CardTitleGroup>

    </CardInner>
  </Card>
);

export default DealProjectionsLoader;
